import { Info } from "lucide-react";
import Title from "../components/ui/Title";
import WebinaireItem from "../components/webinaires/WebinaireItem";
import { ksUserQK, ksWebinairesQK } from "../lib/query-keys";
import { useQuery } from "@tanstack/react-query";
import Box from "../components/ui/Box";
import { peutAccederAuxWebinaires } from "../lib/queries/user-queries";
import { Skeleton } from "../components/ui/skeleton";
import { findAllWebinaires } from "../lib/queries/webinaires-queries";

export default function WebinairesPage() {
  const { data: allowed } = useQuery({
    queryKey: [ksUserQK, "peut-acceder-aux-webinaires"],
    queryFn: peutAccederAuxWebinaires,
  });
  const { data: webinaires } = useQuery({
    queryKey: [ksWebinairesQK],
    queryFn: () => findAllWebinaires(),
    enabled: allowed === true,
    staleTime: 1000 * 60 * 5,
  });

  return (
    <>
      <Title className='mb-5'>Webinaires</Title>
      {allowed === true && !!webinaires ? (
        <>
          <div className='text-gray-600 text-sm italic items-center my-3 flex flex-row gap-4'>
            <Info className='w-4 h-4' />
            <div>Ce programme est provisoire et peut être sujet à modifications.</div>
          </div>
          <div className='flex flex-col gap-4 mt-3'>
            {webinaires.map((webinaire) => (
              <WebinaireItem
                key={webinaire.id}
                titre={webinaire.titre}
                date={webinaire.date}
                replayUrl={webinaire.replayUrl}
                intervenants={webinaire.intervenants}
                liveUrl={webinaire.liveUrl}
                description={webinaire.description}
                heureDebut={webinaire.heureDebut}
                heureOuvertureAcces={webinaire.heureOuvertureAcces}
              />
            ))}
          </div>
        </>
      ) : allowed === false ? (
        <Box className='text-sm'>
          Un abonnement actif en cours avec un pack Or, Argent ou Bronze est nécessaire pour accéder aux webinaires et
          aux replays.
        </Box>
      ) : (
        <div className='flex flex-col gap-4 mt-3'>
          <Skeleton className='w-full h-20' />
          <Skeleton className='w-full h-20' />
          <Skeleton className='w-full h-20' />
          <Skeleton className='w-full h-20' />
          <Skeleton className='w-full h-20' />
        </div>
      )}
    </>
  );
}
